/**
 * 工單巢狀出庫 create／update payload（camel）。
 * 禁止 header：`sourceType`／`sourceId`（後端固定 WORK_ORDER）。
 * 禁止：`lossQty`（超領由後端計算）。
 * line `sourceType`：`INVENTORY_STOCK`｜`PENDING_ALLOCATION`（互斥 id）。
 */

import {
  WORK_ORDER_OUTBOUND_DEFAULT_STOCK_ISSUE_CATEGORY_ID,
} from '#/modules/momMgmt/workOrder/outbound/helper/defaultOutboundStockIssueCategoryId';

export function buildWorkOrderStockIssueCreatePayload(values) {
  return buildWorkOrderStockIssueWritePayload(values);
}

export function buildWorkOrderStockIssueUpdatePayload(values) {
  const updatedAt = values?.updatedAt ?? values?.record?.updatedAt ?? null;
  return buildWorkOrderStockIssueWritePayload(values, { updatedAt });
}

function buildWorkOrderStockIssueWritePayload(values, { updatedAt = null } = {}) {
  const payload = {
    issueDate: values?.issueDate ?? null,
    stockIssueCategoryId: WORK_ORDER_OUTBOUND_DEFAULT_STOCK_ISSUE_CATEGORY_ID,
    issueReason: values?.issueReason ?? null,
    remark: values?.remark ?? null,
    lines: mapOutboundLines(values?.lines),
  };

  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return payload;
}

function mapOutboundLines(lines = []) {
  return (lines ?? []).map((line) => {
    const sourceType = line?.sourceType;
    const mapped = {
      sourceType,
      qty: line?.qty === '' || line?.qty == null ? null : Number(line.qty),
    };

    if (sourceType === 'PENDING_ALLOCATION') {
      mapped.pendingAllocationId = line?.pendingAllocationId;
      return mapped;
    }

    mapped.invStockId = line?.invStockId;
    return mapped;
  });
}
